<app-bottom-sheet #sheet ariaLabel="منوی پرتفوی">
	<ng-template #body>
		<!-- The rows run edge to edge — `-mx-4` cancels the sheet panel's own
			padding, which `px-4` then restores on each row's content.

			Plain buttons rather than `role="menu"`/`role="menuitem"`: the design-system
			button owns its own `<button>`, so a menu role could only go on the wrapper
			around it, and the ARIA menu pattern also owes the trader arrow-key
			navigation this two-row sheet never had. A stack of buttons is what this
			actually is. -->
		<div class="-mx-4 flex flex-col pb-3" data-cy="portfolio-menu-content">
			<ui-button
				variant="ghost"
				size="xl"
				shape="square"
				class="w-full"
				extraButtonClasses="h-11 w-full justify-start gap-2 px-4 text-gray-900 hover:text-gray-900"
				data-cy="portfolio-menu-risk-statement"
				(clicked)="onRiskStatementClick()">
				<ui-icon width="20" height="20" class="text-gray-600" iconName="alert" aria-hidden="true" />
				<span>مشاهده بیانیه ریسک</span>
			</ui-button>
			<ui-button
				variant="ghost"
				size="xl"
				shape="square"
				class="w-full"
				extraButtonClasses="h-11 w-full justify-start gap-2 border-t border-stroke-100 px-4 text-gray-900 hover:text-gray-900"
				data-cy="portfolio-menu-settings"
				(clicked)="onSettingsClick()">
				<ui-icon width="20" height="20" class="text-gray-600" iconName="setting" aria-hidden="true" />
				<span>تنظیمات پرتفوی</span>
			</ui-button>
		</div>
	</ng-template>
</app-bottom-sheet>
